import { render } from "./paymentFailed.vue?vue&type=template&id=6b9082b5&lang=true"
import script from "./paymentFailed.vue?vue&type=script&lang=js"
export * from "./paymentFailed.vue?vue&type=script&lang=js"

import "./paymentFailed.vue?vue&type=style&index=0&id=6b9082b5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__